/**
 * Store script: places the Catalog dropdown (snippets/catalog-menu.liquid) under its menu item and keeps it inside the
 * header row. The theme's other submenus span the row, so they never need this. Adapted from the FrankWorks store's
 * catalogue-menu.js.
 */
class CatalogMenu extends HTMLElement {
  /** @type {HTMLElement | null} */
  #item = null;

  connectedCallback() {
    this.#item = this.closest('.menu-list__list-item');
    this.#item?.addEventListener('pointerenter', this.#place);
    this.#item?.addEventListener('focusin', this.#place);
    this.#place();
  }

  disconnectedCallback() {
    this.#item?.removeEventListener('pointerenter', this.#place);
    this.#item?.removeEventListener('focusin', this.#place);
  }

  /** Line the panel up with the item, moved left only as far as it must be to end inside the row. */
  #place = () => {
    const item = this.#item;
    const submenu = this.closest('.menu-list__submenu');
    const row = submenu instanceof HTMLElement ? submenu.offsetParent : null;
    if (!item || item.slot === 'overflow' || !(submenu instanceof HTMLElement) || !(row instanceof HTMLElement)) return;

    const margin = 16;
    const start = item.getBoundingClientRect().left - row.getBoundingClientRect().left;
    const end = row.clientWidth - submenu.offsetWidth - margin;
    submenu.style.setProperty('--catalog-menu-x', `${Math.round(Math.max(0, Math.min(start, end)))}px`);
  };
}

if (!customElements.get('catalog-menu')) {
  customElements.define('catalog-menu', CatalogMenu);
}
